import React, { useState } from 'react';
import './EditProfilePage.css';
import { useNavigate } from 'react-router-dom';
import ChangePasswordDialog from '../../components/ChangePasswordDialog';

const EditProfilePage = () => {
    const navigate = useNavigate();
    const [openDialog, setOpenDialog] = useState(false);

    return (
        <div className='edit-profile-container'>
            <h1>USER PROFILE</h1>
            <form className='edit-profile-info'>
                <div className='edit-profile-subtitle'>
                    <h2>Account Details</h2>
                </div>
                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='username'>Username</label>
                        <input type='text' name='username' />
                    </div>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='email'>Email</label>
                        <input type='email' name='email' />
                    </div>
                </div>

                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='password'>Password</label>
                        <button
                            type='button'
                            className='edit-profile-password-button'
                            onClick={() => setOpenDialog(true)}
                        >
                            Change Password
                        </button>
                    </div>
                </div>
            </form>

            <form className='edit-profile-info'>
                <div className='edit-profile-subtitle'>
                    <h2>Profile Information</h2>
                </div>
                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='organisation'>Organisation</label>
                        <input type='text' name='organisation' />
                    </div>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='category'>Category</label>
                        <input type='text' name='category' />
                    </div>
                </div>

                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='telephone'>Telephone</label>
                        <input type='tel' name='telephone' />
                    </div>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='faxno'>Fax Number</label>
                        <input type='text' name='faxno' />
                    </div>
                </div>

                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='address1'>Address Line 1</label>
                        <input type='text' name='address1' />
                    </div>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='address2'>Address Line 2</label>
                        <input type='text' name='address2' />
                    </div>
                </div>

                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='postcode'>Postcode</label>
                        <input type='number' name='postcode' />
                    </div>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='city'>City</label>
                        <input type='text' name='city' />
                    </div>
                </div>

                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='state'>State</label>
                        <input type='text' name='state' />
                    </div>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='country'>Country</label>
                        <input type='text' name='country' />
                    </div>
                </div>

                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='website'>Website</label>
                        <input type='text' name='website' style={{ width: '49%' }} />
                    </div>
                </div>
            </form>

            <form className='edit-profile-info'>
                <div className='edit-profile-subtitle'>
                    <h2>Contact Details</h2>
                </div>

                <div className='edit-profile-input' style={{ marginTop: 20 }}>
                    <div className='edit-profile-input-field'>
                        <h3>Primary Contact</h3>
                    </div>
                    <div className='edit-profile-input-field'>
                        <h3>Secondary Contact</h3>
                    </div>
                </div>

                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='name-primary'>Name</label>
                        <input type='text' name='name-primary' />
                    </div>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='name-secondary'>Name</label>
                        <input type='text' name='name-secondary' />
                    </div>
                </div>

                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='telephone-primary'>Telephone</label>
                        <input type='text' name='telephone-primary' />
                    </div>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='telephone-secondary'>Telephone</label>
                        <input type='text' name='telephone-secondary' />
                    </div>
                </div>

                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='designation-primary'>Designation</label>
                        <input type='text' name='designation-primary' />
                    </div>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='designation-secondary'>Designation</label>
                        <input type='text' name='designation-secondary' />
                    </div>
                </div>

                <div className='edit-profile-input'>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='mobile-primary'>Mobile</label>
                        <input type='text' name='mobile-primary' />
                    </div>
                    <div className='edit-profile-input-field'>
                        <label htmlFor='mobile-secondary'>Mobile</label>
                        <input type='text' name='mobile-secondary' />
                    </div>
                </div>
            </form>

            <div className='edit-profile-button'>
                <button
                    className='edit-profile-update-button'
                    type='submit'
                    onClick={() => navigate('/user-profile')}
                >
                    Update
                </button>
                <button
                    className='edit-profile-cancel-button'
                    onClick={() => navigate('/user-profile')}
                >
                    Cancel
                </button>
            </div>
            <ChangePasswordDialog openDialog={openDialog} setOpenDialog={setOpenDialog} />
        </div>
    );
};

export default EditProfilePage;